var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon left",
    clipPath: "url(#clip0_5638_263678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 7V11L2 6L8 1V5H13C15.1217 5 17.1566 5.84285 18.6569 7.34315C20.1571 8.84344 21 10.8783 21 13C21 15.1217 20.1571 17.1566 18.6569 18.6569C17.1566 20.1571 15.1217 21 13 21H4V19H13C14.5913 19 16.1174 18.3679 17.2426 17.2426C18.3679 16.1174 19 14.5913 19 13C19 11.4087 18.3679 9.88258 17.2426 8.75736C16.1174 7.63214 14.5913 7 13 7H8Z",
    fill: "#212836"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5638_263678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/Icon-left.eb6e53ac45ca5e0b6f21909186e7372c.svg";
export { ForwardRef as ReactComponent };